import Skeleton from "react-loading-skeleton";
import {
  formatFirestoreTimestamp,
  formatMoney,
  statusColor,
} from "../../utils";
import { FilterSchema, Stats, Ticket } from "../../utils/types";
import { Pagination } from "../../components/pagination";
import { CustomSelect } from "../../components/custom.select";
import { calculatePriceToDisplay } from "./admin.dashboard";
import { useParams } from "react-router-dom";
import { DocumentData } from "firebase/firestore";
import { toast } from "react-toastify";

export function DashboardMobile({
  eventData,
  stats,
  tickets,
  searchTerm,
  setSearchTerm,
  loading,
  pagination,
  handlePagination,
  ticketTypes,
  selectedTicketType,
  setSelectedTicketType,
  amounts,
  selectedAmount,
  setSelectedAmount,
  statuses,
  selectedStatus,
  setSelectedStatus,
  isInternalAdminVisiting,
  setSelectedGuest,
}: {
  eventData: DocumentData | null;
  stats: Stats;
  tickets: Ticket[];
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  loading: boolean;
  pagination: { page: number; limit: number; total: number };
  handlePagination: (page: number) => void;
  ticketTypes: FilterSchema[];
  selectedTicketType: string;
  setSelectedTicketType: (value: string) => void;
  amounts: FilterSchema[];
  selectedAmount: string;
  setSelectedAmount: (value: string) => void;
  statuses: FilterSchema[];
  selectedStatus: string;
  setSelectedStatus: (value: string) => void;
  isInternalAdminVisiting: boolean;
  setSelectedGuest: (value: Ticket | undefined) => void;
}) {
  const { eventId } = useParams();
  return (
    <div className='dashboard-content mobile'>
      <div className='dashboard-content__title'>
        <h1>{eventData?.title}</h1>
      </div>
      <div className='dashboard-content__stats'>
        <div className='dashboard-content__stats-item'>
          <h4>
            <span>Tickets:</span> {stats.totalTicketsNo}
          </h4>
        </div>
        <div className='dashboard-content__stats-item'>
          <h4>
            <span>Guest checked-in:</span> {stats.guestsCheckedIn}
          </h4>
        </div>
        <div className='dashboard-content__stats-item'>
          <h4>
            <span>Ticket Sales:</span> ₦
            {formatMoney(stats.totalAmountofTicketsSold)}
          </h4>
        </div>
        <div className='dashboard-content__stats-item'>
          <h4>
            <span>Payout:</span> ₦{formatMoney(stats.payout)}
          </h4>
          {isInternalAdminVisiting || !stats.payout ? null : (
            <a className='btn-link' href={`/admin/request-payout/${eventId}`}>
              Request payout
            </a>
          )}
        </div>
        <div className='dashboard-content__stats-item'>
          <h4>
            <span>Balance:</span> ₦{formatMoney(stats.balance)}
          </h4>
        </div>
      </div>
      <div className='dashboard-content__search'>
        <div className='dashboard-content__search-input'>
          <i className='bi bi-search'></i>
          <input
            placeholder='Search name, email...'
            onChange={({ target: { value } }) => setSearchTerm(value)}
          />
        </div>
        <div className='dashboard-content__search-filters'>
          <CustomSelect
            title='Ticket type:'
            titleColor=''
            selectedOption={
              ticketTypes.find((type) => type.value === selectedTicketType)
                ?.text ?? "All"
            }
            options={ticketTypes}
            onChange={(value) => {
              setSelectedTicketType(value);
            }}
          />
          <CustomSelect
            title='Status:'
            titleColor=''
            selectedOption={
              statuses.find((status) => status.value === selectedStatus)
                ?.text ?? "All"
            }
            options={statuses}
            onChange={(value) => {
              setSelectedStatus(value);
            }}
          />
          <CustomSelect
            title='Amount:'
            titleColor=''
            selectedOption={
              amounts.find((amount) => amount.value === selectedAmount)?.text ??
              "All"
            }
            options={amounts}
            onChange={(value) => {
              setSelectedAmount(value);
            }}
          />
        </div>
      </div>
      <div className='dashboard-content__tickets-list'>
        <div className='dashboard-content__tickets-list-item'>
          {loading ? (
            <>
              {[1, 2, 3, 4, 5].map((el) => (
                <li key={el}>
                  <Skeleton count={1} />
                  <Skeleton count={1} />
                  <Skeleton count={1} />
                </li>
              ))}
            </>
          ) : tickets.length ? (
            tickets.map((item, key) => (
              <div
                className='dashboard-content__tickets-list-item-info'
                key={key}
                onClick={() => {
                  if (item.guest) {
                    setSelectedGuest(item);
                    document.getElementById("guest-details-modal-btn")?.click();
                  } else return toast.error("No guest details found");
                }}
              >
                <h4>
                  {item.guest?.firstName} {item.guest?.lastName}
                </h4>
                <p>{item.guest?.email}</p>
                <p>Bought on {formatFirestoreTimestamp(item.createdAt)}</p>
                {(item.checkedInAt ?? []).length ? (
                  <div>
                    Checked in on:{" "}
                    {item.checkedInAt?.map((el) => (
                      <p key={el.toDate().getTime()}>
                        {formatFirestoreTimestamp(el)}
                      </p>
                    ))}
                  </div>
                ) : null}
                <div className='statuses'>
                  <span className={`status ${statusColor(item.status)}`}>
                    {item.status}
                  </span>
                  <p>{calculatePriceToDisplay(item)}</p>
                </div>
              </div>
            ))
          ) : (
            <div className='dashboard-content__tickets-list-item-info'>
              <p>No results found!</p>
            </div>
          )}
        </div>
      </div>
      {/* {tickets.length > pagination.limit ? ( */}
      <Pagination
        pageCount={Number(Math.ceil(pagination.total / pagination.limit))}
        onPageChange={(el) => handlePagination(el)}
        page={Number(pagination.page)}
        pageRange={0}
      />
      {/* ) : null} */}
    </div>
  );
}
